export * from './IconHorizonOrange';
